import { Salle } from "./salle";
import { Users } from "./users";
import { Patients } from "./patients";
import { PrescriptionDialyseJournalier } from ".";

export class ProgrammationLotDialyse {
  id: number;
  nom: string;
  createdAt: Date;
  updatedAt: Date;
  nbMax: number;
  horaires: PrescriptionDialyseJournalier[];
  patients: Patients[];
  createur: Users;
  etat: string;
  salle: Salle;
}



export interface ProgrammationLotRequest {
  id?: number;
  nom: string;
  salle: Salle;
  nbMax: number;
  horaires: PrescriptionDialyseJournalier[];
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/models/programmation-lot-dialyse.ts